module.exports = __webpack_public_path__ + "static/media/Nina Shao.66445c4a.png";